// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31tAh","index":"styles_index__-CRfz"};